import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';

// CMMI Services
import CmmiServices from './pages/services/CmmiServices';
import CmmiAppraisal from './pages/services/cmmi/CmmiAppraisal';
import CmmiConsultancy from './pages/services/cmmi/CmmiConsultancy';
import CmmiTraining from './pages/services/cmmi/CmmiTraining';

// CMMC Services
import CmmcServices from './pages/services/CmmcServices';
import CmmcConsultancy from './pages/services/cmmc/CmmcConsultancy';
import CmmcAssessment from './pages/services/cmmc/CmmcAssessment';

// ISO Services
import IsoServices from './pages/services/IsoServices';
import Iso9001 from './pages/services/iso/Iso9001';
import Iso27001 from './pages/services/iso/Iso27001';
import Iso42001 from './pages/services/iso/Iso42001';
import Iso20000 from './pages/services/iso/Iso20000';
import Iso22301 from './pages/services/iso/Iso22301';
import Iso45001 from './pages/services/iso/Iso45001';
import Iso31000 from './pages/services/iso/Iso31000';
import HipaaServices from './pages/services/other/HipaaServices';

// Digital Services
import DigitalServices from './pages/services/DigitalServices';
import DigitalTransformation from './pages/services/digital/DigitalTransformation';
import SoftwareDevelopment from './pages/services/digital/SoftwareDevelopment';
import DesktopDevelopment from './pages/services/digital/DesktopDevelopment';
import MobileAppDevelopment from './pages/services/digital/MobileAppDevelopment';
import WebDevelopment from './pages/services/digital/WebDevelopment';
import QualityAssurance from './pages/services/digital/QualityAssurance';

// Training Services - To be implemented
import TrainingServices from './pages/services/TrainingServices';

// Other Services
import OtherServices from './pages/services/OtherServices';
import DataEntry from './pages/services/other/DataEntry';
import HrOutsourcing from './pages/services/other/HrOutsourcing';
import ResearchDevelopment from './pages/services/other/ResearchDevelopment';
import TelecomServices from './pages/services/other/TelecomServices';
import SocServices from './pages/services/other/SocServices';
import SemiconductorServices from './pages/services/SemiconductorServices';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            
            {/* Main Services Page */}
            <Route path="/services" element={<Services />} />
            
            {/* CMMI Services */}
            <Route path="/services/cmmi" element={<CmmiServices />} />
            <Route path="/services/cmmi/appraisal" element={<CmmiAppraisal />} />
            <Route path="/services/cmmi/consultancy" element={<CmmiConsultancy />} />
            <Route path="/services/cmmi/training" element={<CmmiTraining />} />
            
            {/* CMMC Services */}
            <Route path="/services/cmmc" element={<CmmcServices />} />
            <Route path="/services/cmmc/consultancy" element={<CmmcConsultancy />} />
            <Route path="/services/cmmc/assessment" element={<CmmcAssessment />} />
            
            {/* ISO Services */}
            <Route path="/services/iso" element={<IsoServices />} />
            <Route path="/services/iso/iso9001" element={<Iso9001 />} />
            <Route path="/services/iso/iso27001" element={<Iso27001 />} />
            <Route path="/services/iso/iso42001" element={<Iso42001 />} />
            <Route path="/services/iso/iso20000" element={<Iso20000 />} />
            <Route path="/services/iso/iso22301" element={<Iso22301 />} />
            <Route path="/services/iso/iso45001" element={<Iso45001 />} />
            <Route path="/services/iso/iso31000" element={<Iso31000 />} />
            <Route path="/services/other/hipaa" element={<HipaaServices />} />
            
            {/* Digital Services */}
            <Route path="/services/digital" element={<DigitalServices />} />
            <Route path="/services/digital/transformation" element={<DigitalTransformation />} />
            <Route path="/services/digital/software" element={<SoftwareDevelopment />} />
            <Route path="/services/digital/desktop" element={<DesktopDevelopment />} />
            <Route path="/services/digital/mobile" element={<MobileAppDevelopment />} />
            <Route path="/services/digital/web" element={<WebDevelopment />} />
            <Route path="/services/digital/qa" element={<QualityAssurance />} />
            
            {/* Semiconductor Services */}
            <Route path="/services/semiconductor" element={<SemiconductorServices />} />
            
            {/* Training Services */}
            <Route path="/services/training" element={<TrainingServices />} />
            
            {/* Other Services */}
            <Route path="/services/other" element={<OtherServices />} />
            <Route path="/services/other/data-entry" element={<DataEntry />} />
            <Route path="/services/other/hr-outsourcing" element={<HrOutsourcing />} />
            <Route path="/services/other/research" element={<ResearchDevelopment />} />
            <Route path="/services/other/telecom" element={<TelecomServices />} />
            <Route path="/services/other/soc" element={<SocServices />} />
            
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
